
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useDialogPluginComponent } from 'quasar';

export default defineComponent({
  name: 'ConfirmDialog',
  props: {
    title: {
      required: false,
      type: [Number, String],
      default: 'Подтверждение',
    },
    message: {
      required: false,
      type: [Number, String],
      default: 'Вы действительно хотите выполнить?',
    },
    confirmLabel: {
      required: false,
      type: [Number, String],
      default: 'Да',
    },
    cancelLabel: {
      required: false,
      type: [Number, String],
      default: 'Нет',
    },
    cancel: {
      required: false,
      default: true,
      type: Boolean,
    },
    persistent: {
      required: false,
      default: true,
      type: Boolean,
    },
    reverseBtn: {
      required: false,
      default: false,
      type: Boolean,
    },
    sizeSmall: {
      required: false,
      default: false,
      type: Boolean,
    },
    size: {
      required: false,
      type: String,
      default: '',
    },
  },
  emits: [
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits,
  ],
  setup(props) {
    // REQUIRED; must be called inside of setup()
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent();

    const classes = computed(() => {
      if (props.size) {
        return `s-modal--${props.size}`;
      }

      return props.sizeSmall ? 's-modal--small' : 's-modal--extra-small';
    });

    return {
      // This is REQUIRED;
      // Need to inject these (from useDialogPluginComponent() call)
      // into the vue scope for the vue html template
      dialogRef,
      onDialogHide,

      // other methods that we used in our vue html template;
      // these are part of our example (so not required)
      onOKClick() {
        // on OK, it is REQUIRED to
        // call onDialogOK (with optional payload)
        onDialogOK();
        // or with payload: onDialogOK({ ... })
        // ...and it will also hide the dialog automatically
      },
      classes,

      // we can passthrough onDialogCancel directly
      onCancelClick: onDialogCancel,
    };
  },
});
